import React from 'react'
import PropTypes from 'prop-types'

/* eslint-disable jsx-a11y/label-has-for */
const FormField = ({
  input,
  type,
  readOnlyValue,
  label,
  disabled,
  meta: { error, touched },
}) => {
  return (
    <div className={type === 'radio' ? '' : 'inputField'}>
      <div htmlFor={input.name} className="select__label">
        {label}
      </div>
      <input
        {...input}
        type={type}
        name={input.name}
        id={input.name}
        readOnly={readOnlyValue}
        disabled={disabled}
      />
      <div className="red-text">{touched && error}</div>
    </div>
  )
}

FormField.propTypes = {
  input: PropTypes.shape({}).isRequired,
  label: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  readOnlyValue: PropTypes.bool,
  meta: PropTypes.shape({
    touched: PropTypes.bool,
    error: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.arrayOf(PropTypes.node, PropTypes.string),
    ]),
    active: PropTypes.bool,
  }),
  disabled: PropTypes.bool,
}

FormField.defaultProps = {
  meta: {
    touched: false,
    error: '',
    active: false,
  },
  readOnlyValue: false,
  disabled: false,
}
export default FormField
